/**
/**
 * Basic Menu functionality
 * Handles hover interactions for the menu structure
 */

class MenuHandler {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupMenus());
    } else {
      this.setupMenus();
    }
  }

  setupMenus() {
    // Find all mega menus (each header menu item)
    const megaMenus = document.querySelectorAll('.mega-menu');
    
    megaMenus.forEach(megaMenu => {
      const menuContent = megaMenu.querySelector('.mega-menu__content');
      if (!menuContent) return;

      // Add hover behavior to the main menu item
      this.addMainMenuHoverBehavior(megaMenu);
      
      // Add hierarchical menu behavior
      this.addHierarchicalMenuBehavior(megaMenu);
    });

    // Add hover behavior for switching between different header menu items
    this.addHeaderMenuHoverBehavior();
  }

  addMainMenuHoverBehavior(megaMenu) {
    const summary = megaMenu.querySelector('summary');
    const menuContent = megaMenu.querySelector('.mega-menu__content');
    if (!summary || !menuContent) return;

    let hoverTimeout = null;

    // Show menu on hover over the entire details element
    megaMenu.addEventListener('mouseenter', (e) => {
      e.preventDefault();
      // Clear any pending close timeout
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
        hoverTimeout = null;
      }
      megaMenu.setAttribute('open', '');
    });

    // Keep menu open when hovering over the content
    menuContent.addEventListener('mouseenter', (e) => {
      e.preventDefault();
      // Clear any pending close timeout
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
        hoverTimeout = null;
      }
      // Ensure menu is open
      megaMenu.setAttribute('open', '');
    });

    // Hide menu when leaving the entire mega menu area
    megaMenu.addEventListener('mouseleave', (e) => {
      // Set a timeout to close the menu
      hoverTimeout = setTimeout(() => {
        megaMenu.removeAttribute('open');
        hoverTimeout = null;
      }, 200); // 200ms delay before closing
    });

    // Handle click as fallback
    summary.addEventListener('click', (e) => {
      // If menu is not open, open it
      if (!megaMenu.hasAttribute('open')) {
        e.preventDefault();
        megaMenu.setAttribute('open', '');
      }
    });
  }


  addHierarchicalMenuBehavior(megaMenu) {
    // Simplified menu - no complex hierarchical behavior needed
    // The menu now uses a simple list structure
    return;
  }

  addHeaderMenuHoverBehavior() {
    // Simplified - no complex header menu switching needed
    return;
  }

  resetHierarchicalMenu(megaMenu) {
    // Simplified - no hierarchical reset needed for simple list
    return;
  }

}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new MenuHandler();
});

// Also initialize if DOM is already loaded
if (document.readyState !== 'loading') {
  new MenuHandler();
}